<template>
  <div />
</template>

<script>

/**
 * Vue: Image product carousel (image-product-carousel)
 * -----------------------------------------------------------------------------
 * Section of images to display products in a different manner.
 * - Static section.
 *
 */
import Splide from '@splidejs/splide'
import { values as breakpointValues } from "~/config/breakpoints"

export default {
  name: 'ImageProductCarousel',

  props: {
    sectionId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      carousel: false,
      selectors: {},
    }
  },

  mounted() {
    this.setSelectors()
    this.initCarousel()
  },

  methods: {

    /**
     * Set selectors.
     */
    setSelectors() {
      const container = document.querySelector(`#vue-element [js-image-product-carousel="${this.sectionId}`)

      this.selectors = {
        container,
        carousel: container.querySelector('[js-splide="carousel"]'),
        progressBar: container.querySelector('[js-image-product-carousel="progress-bar"]'),
      }
    },

    /**
     * Init Splide carousel.
     */
    initCarousel() {
      if (!this.selectors.carousel) {
        return
      }

      const hasFeaturedImage = this.selectors.container.dataset.hasFeaturedImage === 'true'
      const desktopSlidesPerPage = hasFeaturedImage ? 2 : 3

      const config = {
        breakpoints: {
          [breakpointValues.m]: {
            gap: 0,
            perPage: 1,
            perMove: 1,
          },
          [breakpointValues.l]: {
            keyboard: true,
            perPage: desktopSlidesPerPage,
            perMove: 1,
            gap: 'var(--gutter-mobile)',
          },
        },
        arrows: false,
        rewind: true,
        pagination: false,
        mediaQuery: 'min',
        drag: true,
        type: 'slide',
      }

      this.carousel = new Splide(this.selectors.carousel, config)

      const bar = this.selectors.progressBar

      this.carousel.on('mounted move', () => {
        const end = this.carousel.Components.Controller.getEnd() + 1
        const width = 100 / end
        const rate = Math.min((this.carousel.index + 1) / end, 1)
        bar.style.width = `${width}%`
        bar.style.left = `${100 * rate - width}%`
      })

      this.carousel.mount()
    },
  },
}
</script>

<style lang="scss">
@import './image-product-carousel';
</style>
